import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LoaderServiceService } from './loader-service.service';
import { Geolocation } from '@capacitor/geolocation';
import { GoogleApiKeyService } from './google-api-key.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { environment } from 'src/environments/environment';

interface AddressComponent {
  long_name: string;
  short_name: string;
  types: string[];
}

interface GeocodeResult {
  results: any
}

@Injectable({
  providedIn: 'root'
})
export class LocationService {

  constructor(private http: HttpClient,private ls:LoaderServiceService, private keyService: GoogleApiKeyService, private snakbar:MatSnackBar
) {}

  async getCurrentLocation(): Promise<any> {
    return new Promise(async (resolve, reject) => {
      if ('geolocation' in navigator) {

        navigator.geolocation.getCurrentPosition(
          async position => {
            // this.ls.showLoader = true
            const { latitude, longitude } = position.coords;
            try {
              const locationInfo = await this.getLocationInfoForWeb(latitude, longitude);
              resolve({ latitude, longitude, ...locationInfo });
            } catch (error) {
              reject('Error getting location info');
            }
          },
          error => reject(error)
        );
      } else {
        reject('Geolocation is not supported by your browser.');
      }
    });
  }


  async getCurrentLocationForMobile(): Promise<any> {
    return new Promise(async (resolve, reject) => {
      try {
        const position = await Geolocation.getCurrentPosition();
        const { latitude, longitude } = position.coords;
        console.log(position.coords);
        
        try {

          const locationInfo = await this.getLocationInfo(latitude, longitude);
          resolve({ latitude, longitude, ...locationInfo });
        } catch (error) {
          console.error('Error getting location info', error);
          reject('Error getting location info');
        }
  
      } catch (err) {
        console.error('Error fetching location', err);
        reject(err);
      }
    });
  }
  


  private async getLocationInfo(latitude: number, longitude: number): Promise<any> {
    const apiKey = this.keyService.getApiKey();
    const apiUrl = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${apiKey}`;
    // if(!environment.production){
    //   this.snakbar.open('GOOGLE API KEY USED: ' + apiKey,'Ok')

    // }
    try {
      const response = await this.http.get<GeocodeResult>(apiUrl).toPromise();
      console.log(response);
      
      const addressComponents = response?.results[0].address_components;
      const formattedAddress = response?.results[0].formatted_address;

      // Extract city, state, and country from address components
      const city = this.extractAddressComponent(addressComponents, 'locality');
      const state = this.extractAddressComponent(addressComponents, 'administrative_area_level_1');
      const country = this.extractAddressComponent(addressComponents, 'country');
      const sublocality_level_1 = this.extractAddressComponent(addressComponents, 'sublocality_level_1');

      return { city, state, country, sublocality_level_1, formattedAddress };
    } catch (error) {
      throw error;
    }
  }

  private async getLocationInfoForWeb(latitude: number, longitude: number): Promise<any> {
    const apiKey = 'AIzaSyDX8co0kvPufyqJvaTCYN0ge4PTCAtjrAk'
    const apiUrl = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${apiKey}`;
    // if(!environment.production){
    //   this.snakbar.open('GOOGLE API KEY USED: ' + apiKey,'Ok')

    // }
    try {
      const response = await this.http.get<GeocodeResult>(apiUrl).toPromise();
      console.log(response);
      
      const addressComponents = response?.results[0].address_components;
      const formattedAddress = response?.results[0].formatted_address;

      // Extract city, state, and country from address components
      const city = this.extractAddressComponent(addressComponents, 'locality');
      const state = this.extractAddressComponent(addressComponents, 'administrative_area_level_1');
      const country = this.extractAddressComponent(addressComponents, 'country');
      const sublocality_level_1 = this.extractAddressComponent(addressComponents, 'sublocality_level_1');

      return { city, state, country, sublocality_level_1, formattedAddress };
    } catch (error) {
      throw error;
    }
  }

  private extractAddressComponent(addressComponents: AddressComponent[], type: string): string {
    const component = addressComponents.find(component => component.types.includes(type));
    return component ? component.long_name : '';
  }
}
